import api from "./api";
import { APIs } from "../constants/APIConstants";
import { GLOBAL_MEETING_DATA } from "../constants/PublicVariables";

export default class OnLoadFunctionAPI {
    checkIsCompanyAvailable(req) {
        return api.get(APIs.ISCOMPANYAVAILABLE + encodeURIComponent(req.domainURL));
    }

    getPrivacyPolicy(req) {
        return api.get(APIs.PRIVACY_POLICY.replace("{SessionId}", req));
    }

    getCountryList() {
        return api.get(APIs.COUNTRY_LIST);
    }

    inviteParticipant(req) {
        return api.post(APIs.INVITE_PARTICIPANT.replace("{SessionId}", GLOBAL_MEETING_DATA.sessionId), req);
    }

    sessionStats(req) {
        return api.postWithAnalyticsAPI(APIs.SESSION_STATS, req);
    }
}
